import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import { ClipLoader, BounceLoader } from 'react-spinners';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import getTaskWorkerState from 'utils/work/getTaskWorkerState';
var Text = _Typography.Text;
var slowLoad = function slowLoad() {
  return __jsx("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, __jsx("div", {
    style: {
      padding: 25
    }
  }, __jsx(BounceLoader, {
    size: 50,
    color: "#8f0b10",
    css: {
      display: 'block'
    }
  })), __jsx("div", {
    style: {
      textAlign: 'center',
      marginBottom: '1em'
    }
  }, __jsx("p", null, __jsx(Text, null, "This will take a few minutes...")), __jsx("p", null, __jsx(Text, {
    type: "secondary"
  }, "We're setting up your analysis. Please wait."))));
};
var fastLoad = function fastLoad() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return __jsx("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, __jsx("div", {
    style: {
      padding: 25
    }
  }, __jsx(ClipLoader, {
    size: 50,
    color: "#8f0b10"
  })), __jsx("div", {
    style: {
      textAlign: 'center',
      marginBottom: '1em'
    }
  }, __jsx(Text, null, message !== null && message !== void 0 ? message : "We're getting your data ...")));
};
var Loader = function Loader(_ref) {
  var experimentId = _ref.experimentId,
    taskName = _ref.taskName;
  var experimentBackendStatus = useSelector(function (state) {
    var _state$backendStatus;
    return (_state$backendStatus = state.backendStatus) === null || _state$backendStatus === void 0 ? void 0 : _state$backendStatus[experimentId];
  });
  var taskState = useMemo(function () {
    return taskName ? getTaskWorkerState(experimentBackendStatus, taskName) : null;
  }, [experimentBackendStatus, taskName]);
  if (taskState !== null && taskState !== void 0 && taskState.userMessage) return __jsx("div", null, fastLoad(taskState.userMessage));
  if (taskState !== null && taskState !== void 0 && taskState.provisioning) return __jsx("div", null, slowLoad());
  return __jsx("div", null, fastLoad());
};
Loader.defaultProps = {
  taskName: null
};
export default Loader;
export { fastLoad, slowLoad };